<template>
  <div class="split-section d-flex align-items-center flex-wrap info-bg">
    <div
      class="left-infosec d-flex align-items-center flex-wrap align-items-center justify-content-center text-center rsvp"
    >
      <div class="leftblock-wrap">
        <div class="info-detail">
          <h2 v-if="invalidLink">{{message}}</h2>
          <h2 v-else>{{message}}</h2>
        </div>
        <div class="info-detail">
          <RouterLink to="/">
            <button
            color="#fff !important"
                      type="submit"
                      class="btn btn-primary"
                      :disabled="disabled == true"
                    >
                  Continue
            </button>
        </RouterLink>
        </div>
        <div class="store-link">
          <img src="assets/images/appstore.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../routes";

export default {
  data() {
    return {
      activateSuccess: "",
      invalidLink: "",
      token: this.$route.query.token,
      message: "",
      validationMessage: ""
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_BASE_API_URL + "/auth/activate/" + this.token,
        {}
      )
      .then(response => {
        this.message = response.data.message;
        if (response.status == 200) {
          this.activateSuccess = true;
        } else {
          this.invalidLink = true;
        }
      })
      .catch(error => console.log(error.message));
  }
};
</script>

<style>
</style>
